import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import PixelTest from './views/PixelTest.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/test',
            name: 'Test',
            component: PixelTest
        },
        {
            path: '/about',
            name: 'about',
            // code-splitting pour charger cette route en lazy-loading
            component: () => import('./views/About.vue')
        }
    ]
});
